import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'

import './index.css'
import './styles/theme.css'
import './styles/typography.css'
import './styles/animations.css'
import './styles/portfolio-section.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
